@if (productOverview) {
  @if (!isMobileView) {
    <div class="container-margin">
      <div class="row row-item">
        <div class="image-and-highlights">
          <div class="img-holder">
            <app-product-image
              loading="eager"
              [picture]="productOverview.picture"
              [name]="productOverview.name"
            />
          </div>
          <div class="highlights-section">
            @if (productHighlights) {
              <app-sustainability-highlights
                [productHighlights]="productHighlights"
              >
              </app-sustainability-highlights>
            }
          </div>
        </div>
        <div class="product-info-container">
          <span class="large-font">{{ productOverview.brand }}</span>
          <span class="bold x-large-font margin-top-10">{{
            productOverview.name
          }}</span>
          <mat-divider></mat-divider>
          <div class="grid-container margin-top-10">
            <span>{{
              translationService.getMarketplaceCategoryLabelText()
            }}</span>
            <span
              >{{
                translationService.getMarketplaceCategoryText(
                  productOverview.marketplaceCategory
                )
              }}
              @if (productOverview.marketplaceSubcategory) {
                -
                {{
                  translationService.getMarketplaceSubcategoryText(
                    productOverview.marketplaceSubcategory
                  )
                }}
              }
            </span>
            <span>{{ translationService.getMarketplaceRequestUnitText() }}</span
            ><span>{{
              translationService.getMarketplaceRequestUnitValueText(
                productOverview.requestUnit
              )
            }}</span>
            <span>{{ translationService.getMarketplacePriceText() }}</span>
            <span>
              @if (
                productOverview.priceAmount !== null &&
                productOverview.priceAmount !== undefined
              ) {
                {{ productOverview.priceAmount }}
                {{ productOverview.priceCurrency }} /
                {{
                  translationService.getMarketplaceRequestUnitValueText(
                    productOverview.requestUnit
                  )
                }}
              } @else {
                <span>{{
                  translationService.getMarketplaceUnknownText()
                }}</span>
              }
            </span>
            @if (productOverview.condition) {
              <span>{{ translationService.getMarketplaceConditionText() }}</span
              ><span>{{
                translationService.getMarketplaceConditionValueText(
                  productOverview.condition
                )
              }}</span>
            }
            @if (
              productOverview.droneFlightTimeMinutes !== null &&
              productOverview.droneFlightTimeMinutes !== undefined
            ) {
              <span>{{
                translationService.getMarketplaceFlightTimeText()
              }}</span
              ><span
                >{{ productOverview.droneFlightTimeMinutes }}
                <span>{{
                  translationService.getMarketplaceMinutesText()
                }}</span></span
              >
            }
            @if (productOverview.droneType) {
              <span>{{ translationService.getMarketplaceDroneTypeText() }}</span
              ><span>{{ productOverview.droneType }}</span>
            }
            @if (productOverview.droneVideoResolution) {
              <span>{{
                translationService.getMarketplaceVideoResolutionText()
              }}</span
              ><span>{{ productOverview.droneVideoResolution }}</span>
            }
            @if (productOverview.droneSensorSize) {
              <span>{{
                translationService.getMarketplaceSensorSizeText()
              }}</span
              ><span
                >{{ productOverview.droneSensorSize }}
                {{ translationService.getInText() }}</span
              >
            }
            @if (
              productOverview.droneFpv !== null &&
              productOverview.droneFpv !== undefined
            ) {
              <span>{{ translationService.getMarketplaceFpvText() }}</span
              ><span>{{
                productOverview.droneFpv
                  ? translationService.getYesText()
                  : translationService.getNoText()
              }}</span>
            }
          </div>
          <mat-divider></mat-divider>
          <div class="grid-container margin-top-10">
            <span>{{ translationService.getSKUText() }}</span>
            <span>{{ productOverview.sku }}</span>
            <span>{{ translationService.getBatchText() }}</span>
            <span class="range">
              @if (productOverview.batch_upper) {
                {{ productOverview.batch }}
                <br />
                {{ translationService.getToText() }}
                <br />
                {{ productOverview.batch_upper }}
              } @else {
                {{ productOverview.batch }}
              }
            </span>
            <span>{{ translationService.getWeightText() }}</span>
            <span
              >{{ productOverview.measureValue
              }}{{ productOverview.measureUnit }}</span
            >
            <span>{{ translationService.getSerialText() }}</span>
            <span class="range">
              @if (productOverview.serial_upper) {
                {{ productOverview.serial }}
                <br />
                {{ translationService.getToText() }}
                <br />
                {{ productOverview.serial_upper }}
              } @else {
                {{ productOverview.serial }}
              }
            </span>
          </div>
          @if (productOverview.packageType) {
            <mat-divider></mat-divider>
            <div class="packaging-section margin-top-10">
              <div class="package-section-row">
                <img
                  ngSrc="assets/box.svg"
                  height="24"
                  width="24"
                  class="box-img"
                  [alt]="translationService.getPackagingBoxText()"
                />
                <span>
                  {{ translationService.getProductPackageIntroText() }}
                  <span class="package-type">{{
                    productOverview.packageType
                  }}</span>
                  {{ translationService.getProductPackagingSuffixText() }}
                </span>
              </div>
            </div>
          }
          <mat-divider></mat-divider>
          <div class="view-links-section">
            <div class="link-row-item">
              <mat-icon>science</mat-icon>
              <button class="link-btn" (click)="goToProductChemistry()">
                {{ translationService.getViewFullComponentBreakdownText() }}
              </button>
            </div>
            <div class="link-row-item">
              <mat-icon class="slant-arrow-icon">call_made</mat-icon>
              <button class="link-btn" (click)="showSubstancesOfConcern()">
                {{ translationService.getSubstancesOfConcernText() }}
              </button>
            </div>

            <div class="link-row-item">
              <mat-icon class="green-icon">recycling</mat-icon>
              <button class="link-btn" (click)="showRecycledContent()">
                {{ translationService.getShowRecycledContentText() }}
              </button>
            </div>
          </div>
          <mat-divider></mat-divider>
          <div class="qr-section margin-top-10">
            <qrcode
              #qrCodeElement
              [qrdata]="qrCodeValue"
              [width]="128"
              [colorDark]="'#000000'"
              [colorLight]="'#ffffff'"
              [margin]="0"
            ></qrcode>
            <div class="margin-top-10">
              <button
                type="button"
                mat-raised-button
                extended
                color="accent"
                (click)="downloadQRCode()"
              >
                <mat-icon>download</mat-icon>
                {{ translationService.getDownloadText() }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <mat-divider class="description-divider"></mat-divider>
      <p>{{ productOverview.description }}</p>
      <app-product-custom-fields [fields]="productOverview.customFields" />
    </div>
  } @else {
    <div class="container-mobile">
      <div class="img-holder-mobile">
        <app-product-image
          loading="eager"
          [picture]="productOverview.picture"
          [name]="productOverview.name"
        />
      </div>
      <div class="product-info-container-mobile">
        <span class="large-font">{{ productOverview.brand }}</span>
        <span class="bold xx-large-font margin-top-10">{{
          productOverview.name
        }}</span>
        <mat-divider></mat-divider>
        @if (productHighlights) {
          <app-sustainability-highlights
            [productHighlights]="productHighlights"
            [isMobileView]="true"
          >
          </app-sustainability-highlights>
        }

        <mat-divider></mat-divider>
        <div class="grid-container margin-top-20">
          <span>{{
            translationService.getMarketplaceCategoryLabelText()
          }}</span>
          <span
            >{{
              translationService.getMarketplaceCategoryText(
                productOverview.marketplaceCategory
              )
            }}
            @if (productOverview.marketplaceSubcategory) {
              -
              {{
                translationService.getMarketplaceSubcategoryText(
                  productOverview.marketplaceSubcategory
                )
              }}
            }
          </span>
          <span>{{ translationService.getMarketplaceRequestUnitText() }}</span
          ><span>{{
            translationService.getMarketplaceRequestUnitValueText(
              productOverview.requestUnit
            )
          }}</span>
          <span>{{ translationService.getMarketplacePriceText() }}</span>
          <span>
            @if (
              productOverview.priceAmount !== null &&
              productOverview.priceAmount !== undefined
            ) {
              {{ productOverview.priceAmount }}
              {{ productOverview.priceCurrency }} /
              {{
                translationService.getMarketplaceRequestUnitValueText(
                  productOverview.requestUnit
                )
              }}
            } @else {
              <span>{{ translationService.getMarketplaceUnknownText() }}</span>
            }
          </span>
          @if (productOverview.condition) {
            <span>{{ translationService.getMarketplaceConditionText() }}</span
            ><span>{{
              translationService.getMarketplaceConditionValueText(
                productOverview.condition
              )
            }}</span>
          }
          @if (
            productOverview.droneFlightTimeMinutes !== null &&
            productOverview.droneFlightTimeMinutes !== undefined
          ) {
            <span>{{ translationService.getMarketplaceFlightTimeText() }}</span
            ><span
              >{{ productOverview.droneFlightTimeMinutes }}
              <span>{{
                translationService.getMarketplaceMinutesText()
              }}</span></span
            >
          }
          @if (productOverview.droneType) {
            <span>{{ translationService.getMarketplaceDroneTypeText() }}</span
            ><span>{{ productOverview.droneType }}</span>
          }
          @if (productOverview.droneVideoResolution) {
            <span>{{
              translationService.getMarketplaceVideoResolutionText()
            }}</span
            ><span>{{ productOverview.droneVideoResolution }}</span>
          }
          @if (productOverview.droneSensorSize) {
            <span>{{ translationService.getMarketplaceSensorSizeText() }}</span
            ><span
              >{{ productOverview.droneSensorSize }}
              {{ translationService.getInText() }}</span
            >
          }
          @if (
            productOverview.droneFpv !== null &&
            productOverview.droneFpv !== undefined
          ) {
            <span>{{ translationService.getMarketplaceFpvText() }}</span
            ><span>{{
              productOverview.droneFpv
                ? translationService.getYesText()
                : translationService.getNoText()
            }}</span>
          }
          <span class="large-font">{{ translationService.getSKUText() }}</span>
          <span class="large-font">{{ productOverview.sku }}</span>
          <span class="large-font">{{
            translationService.getBatchText()
          }}</span>
          <span class="range large-font">
            @if (productOverview.batch_upper) {
              {{ productOverview.batch }}
              <br />
              {{ translationService.getToText() }}
              <br />
              {{ productOverview.batch_upper }}
            } @else {
              {{ productOverview.batch }}
            }
          </span>
          <span class="large-font">{{
            translationService.getWeightText()
          }}</span>
          <span
            >{{ productOverview.measureValue
            }}{{ productOverview.measureUnit }}</span
          >
          <span class="large-font">{{
            translationService.getSerialText()
          }}</span>
          <span class="range large-font">
            @if (productOverview.serial_upper) {
              {{ productOverview.serial }}
              <br />
              {{ translationService.getToText() }}
              <br />
              {{ productOverview.serial_upper }}
            } @else {
              {{ productOverview.serial }}
            }
          </span>
        </div>
        @if (productOverview.packageType) {
          <mat-divider class="margin-top-10"></mat-divider>
          <div class="packaging-section margin-top-10">
            <div class="package-section-row">
              <img
                ngSrc="assets/box.svg"
                height="24"
                width="24"
                class="box-img"
                [alt]="translationService.getPackagingBoxText()"
              />
              <span>
                {{ translationService.getProductPackageIntroText() }}
                <span class="package-type">{{
                  productOverview.packageType
                }}</span>
                {{ translationService.getProductPackagingSuffixText() }}
              </span>
            </div>
          </div>
        }
        <mat-divider class="margin-top-10"></mat-divider>
        <div class="link-row-item margin-top-10">
          <mat-icon>science</mat-icon>
          <button class="link-btn" (click)="goToProductChemistry()">
            {{ translationService.getViewFullComponentBreakdownText() }}
          </button>
        </div>

        <div class="link-row-item margin-top-10">
          <mat-icon class="green-icon">recycling</mat-icon>
          <button class="link-btn" (click)="showRecycledContent()">
            {{ translationService.getShowRecycledContentText() }}
          </button>
        </div>

        <div class="link-row-item margin-top-10">
          <mat-icon class="slant-arrow-icon">call_made</mat-icon>
          <button class="link-btn" (click)="showSubstancesOfConcern()">
            {{ translationService.getSubstancesOfConcernText() }}
          </button>
        </div>

        <mat-divider class="margin-top-10"></mat-divider>
        <p class="larger-font margin-top-20">
          {{ productOverview.description }}
        </p>

        <mat-divider class="margin-top-20"></mat-divider>
        <div class="qr-section margin-top-20">
          <qrcode
            #qrCodeElement
            [qrdata]="qrCodeValue"
            [width]="128"
            [colorDark]="'#000000'"
            [colorLight]="'#ffffff'"
            [margin]="0"
          ></qrcode>
          <div class="margin-top-10">
            <button
              type="button"
              mat-raised-button
              extended
              color="accent"
              (click)="downloadQRCode()"
            >
              <mat-icon>download</mat-icon>
              {{ translationService.getDownloadText() }}
            </button>
          </div>
        </div>
        <app-product-custom-fields [fields]="productOverview.customFields" />
      </div>
    </div>
  }
}
